import { IOrderSale } from '../../order-sale-form';
import { ValidationError } from 'yup';

export function doKiloPriceMatchOrderRequestProductKiloPrice(
    value: any,
    context: any,
): ValidationError | boolean {
    const { kilo_price, product } = context.from[0]
        .value as IOrderSale['order_sale_products'][number];
    const { order_request } = context.from[1].value as IOrderSale;
    const orderRequestRemainingProduct =
        order_request?.order_request_remaining_products.find(
            (rp) => rp?.product?.id === product?.id,
        );
    if (!orderRequestRemainingProduct) return true;

    const currentKiloPriceInOrderRequest =
        orderRequestRemainingProduct?.kilo_price;

    const selectedKiloPrice = Number(kilo_price);

    if (selectedKiloPrice !== currentKiloPriceInOrderRequest) {
        return context.createError({
            message: `El precio de los producto no es igual al establecido en el pedido (precio en el pedido: ${currentKiloPriceInOrderRequest})`,
        });
    }

    return true;
}
